<html>
  <head>
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.css"
    />
  </head>

  <body>
    <div class="master-settings-option" [hidden]="hidden">
      <div id="clickableAwesomeFont" (click)="refreshMasterSettings($event)" [hidden]="resetHidden">
        <i title="Reset" class="fas fa-arrows-rotate defaultButton"></i>
      </div>
      <div id="clickableAwesomeFont" (click)="updateMasterSettings($event)">
        <i title="Edit" class="far fa-pen-to-square editButton"></i>
      </div>
      <div id="clickableAwesomeFont" (click)="deleteMasterSettings($event)">
        <i title="Disable" class="far fa-trash-can deleteButton"></i>
      </div>
    </div>
  </body>
</html>
